import React from 'react';
import Storage from "common/js/Storage";
import { Urls } from 'common/js/urls';


const Product = props => {
    
    const getProductImage = () => {
        const ImgComp = props.imgs[props.name];
        return <ImgComp className="marg-r-16" />
    };

    const productHandler = () => {
        if(props.disabled) return;
        Storage.addCookie('product', props.name);
        window.location.replace(Urls.BaseUrl());
    }

    const formatName = (name) => {
        if(name === 'AMS') return name;
        return name.replace('_', '').toLowerCase();
    }

    return (
        <div className={`product-box flex-centered ${props.disabled ? 'disabled' : ''}`} onClick={productHandler} >
            <div className='flex-start'>
                <div className="product-box__img">{getProductImage()}</div>

                <div className="product-box__title-section">
                    <div className={`product-box__title-section__title ${props.name}`}>
                        {formatName(props.name)}
                    </div>
                    <div className="product-box__title-section__description">{props.texts[props.name]}</div>
                </div>
            </div>
        </div>
    );
}
 
export default Product;